import React, { useLayoutEffect, useRef, useState } from 'react';
import { Button, Modal } from 'antd';
import PdfReader from './PdfReader';

function ReadBookModal({
  isModalOpen,
  handleCancel,
  fileUrl,
  dataText,
  extension,
  password
}) {
  const ref = useRef(null);

  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    setWidth(ref.current.offsetWidth);
  }, []);

  return (
    <Modal
      className="!w-[350px] sm:!w-[640px] md:!w-[760px] lg:!w-[1024px] xl:!w-[1200px]"
      title="Nội dung tài liệu"
      open={isModalOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key="return" onClick={handleCancel}>
          Thoát
        </Button>,
      ]}
    >
      <div ref={ref}>
        {extension === 'pdf' ? (
          <PdfReader src={fileUrl} width={width} password={password} />
        ) : (
          <pre>{dataText}</pre>
        )}
      </div>
    </Modal>
  );
}

export default ReadBookModal;
